import { SET_CLIENT_STORY } from "../actions/action-types.js";

export default function clientStory(state = {}, {type, payload}) {
    switch (type) {
        case SET_CLIENT_STORY:
            return (state = payload)
        default:
            return state
    }
}